module.exports = __webpack_public_path__ + "static/img/earth_elemental.c852d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/earth_elemental.png
// module id = equx
// module chunks = 0